import { createApiAction } from '@app/packages/api/utils'
import type { V3GetSupportEventsParams } from '@app/packages/api/v3/types/params'
import type { V3GetSupportEventResponse, V3GetSupportEventsResponse, V3PostSupportEventRegistrationResponse } from '@app/packages/api/v3/types/responses'

export const getSupportEvents = (params?: V3GetSupportEventsParams) =>
  createApiAction('getSupportEvents', dispatch =>
    dispatch<V3GetSupportEventsResponse>({
      endpoint: `/api/v3/support_events${buildSupportEventsQuery(params)}`,
      method: 'GET',
    })
  )

export const getSupportEventById = (id: string) =>
  createApiAction('getSupportEventById', dispatch =>
    dispatch<V3GetSupportEventResponse>({
      endpoint: `/api/v3/support_events/${encodeURIComponent(id)}`,
      method: 'GET',
    })
  )

export const postSupportEventRegistration = (supportEventId: string) =>
  createApiAction('postSupportEventRegistration', dispatch =>
    dispatch<V3PostSupportEventRegistrationResponse>({
      endpoint: `/api/v3/support_events/${encodeURIComponent(supportEventId)}/registrations`,
      method: 'POST',
      body: JSON.stringify({ data: { type: 'support_event_registrations' } }),
    })
  )

export const deleteSupportEventRegistration = (supportEventId: string) =>
  createApiAction('deleteSupportEventRegistration', dispatch =>
    dispatch<void>({
      endpoint: `/api/v3/support_events/${encodeURIComponent(supportEventId)}/registrations`,
      method: 'DELETE',
    })
  )

const buildSupportEventsQuery = (params?: V3GetSupportEventsParams): string => {
  if (!params) return ''
  const search = new URLSearchParams()
  if (params.event_types?.length) search.set('filter[event_type]', params.event_types.join(','))
  if (params.sort) search.set('sort', params.sort)
  if (params.page?.number !== undefined) search.set('page[number]', String(params.page.number))
  if (params.page?.size !== undefined) search.set('page[size]', String(params.page.size))
  if (params.include) search.set('include', params.include)
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}
